export default {

    get() {
        return localStorage.getItem(key);
    },

    set(key, value) {
        localStorage.setItem(key, value);
    },

    toggleValueInArray(key, value) {
        let localStorageValue = this.getArray(key);
        if (localStorageValue.includes(value)) {
            localStorageValue = localStorageValue.filter(item => item !== value)
        }
        else {
            localStorageValue.push(value);
        }
        this.set(key, localStorageValue)
    },

    getArray(key) {
        let value = localStorage.getItem(key);
        return value = value ? value.split(',') : [];
    },
    
    valueExistInArray(key, value) {
        var storageArray = this.getArray(key);
        if (storageArray.includes(value)) {
            return true
        }
        return false;
    }
}
